import { render, staticRenderFns } from "./MiniChannel.vue?vue&type=template&id=10d738b0&scoped=true&"
import script from "./MiniChannel.vue?vue&type=script&lang=js&"
export * from "./MiniChannel.vue?vue&type=script&lang=js&"
import style0 from "./MiniChannel.vue?vue&type=style&index=0&id=10d738b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d738b0",
  null
  
)

export default component.exports